import { render } from "./CadastroEstadosView.vue?vue&type=template&id=1476986a"
import script from "./CadastroEstadosView.vue?vue&type=script&lang=js"
export * from "./CadastroEstadosView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\SGCAD25\\Multifianca\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__